/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    AssignESMOrganisationRequest,
    AssignESMOrganisationResponse,
    CompleteESMInspectionResponse,
    CreateESMScheduleRequest,
    CreateESMScheduleResponse,
    EditESMScheduleRequest,
    EditESMScheduleResponse,
    GetBuildingEsmScheduleByIdParams,
    GetESMInspectionDetailResponse,
    GetESMMastersResponse,
    GetESMScheduleResponse,
    ResolveESMDefectResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
    | string
    | number
    | boolean
    | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            if (value !== undefined) {
                filteredParams[key] = value;
            }
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (item) =>
                    item != null &&
                    (typeof item === 'string' ||
                        typeof item === 'number' ||
                        typeof item === 'boolean')
            ) as Array<string | number | boolean>;
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (
            value != null &&
            (typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')
        ) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class BuildingMaintenanceApiService {
    private readonly http = inject(HttpClient);
    /**
     * Resolves an ESM defect and uploads mandatory resolution evidence.
     * @summary Resolve ESM defect
     */
    createBuildingEsmDefectResolve<TData = ResolveESMDefectResponse>(
        buildingId: string,
        defectId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingEsmDefectResolve<TData = ResolveESMDefectResponse>(
        buildingId: string,
        defectId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingEsmDefectResolve<TData = ResolveESMDefectResponse>(
        buildingId: string,
        defectId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingEsmDefectResolve<TData = ResolveESMDefectResponse>(
        buildingId: string,
        defectId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-defects/${defectId}/resolve`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-defects/${defectId}/resolve`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/esm-defects/${defectId}/resolve`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns completion notes and attached evidence for a specific inspection.
     * @summary Get ESM inspection detail
     */
    getBuildingEsmInspectionById<TData = GetESMInspectionDetailResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingEsmInspectionById<TData = GetESMInspectionDetailResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingEsmInspectionById<TData = GetESMInspectionDetailResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingEsmInspectionById<TData = GetESMInspectionDetailResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Completes an inspection, uploads completion evidence, optionally records defects, and optionally resolves defects in the same submission. The manifest can optionally include currentDate so month-boundary actionability uses the caller's local time.
     * @summary Complete ESM inspection
     */
    completeBuildingEsmInspection<TData = CompleteESMInspectionResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    completeBuildingEsmInspection<TData = CompleteESMInspectionResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    completeBuildingEsmInspection<TData = CompleteESMInspectionResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    completeBuildingEsmInspection<TData = CompleteESMInspectionResponse>(
        buildingId: string,
        inspectionId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}/complete`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}/complete`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/esm-inspections/${inspectionId}/complete`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns grouped ESM masters available to the authenticated user's organisation.
     * @summary Get ESM masters for building
     */
    listBuildingEsmMasters<TData = GetESMMastersResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingEsmMasters<TData = GetESMMastersResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingEsmMasters<TData = GetESMMastersResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingEsmMasters<TData = GetESMMastersResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-masters`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-masters`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/esm-masters`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Creates a schedule for a building and generates inspections from month/frequency selections.
     * @summary Create ESM schedule
     */
    createBuildingEsmSchedule<TData = CreateESMScheduleResponse>(
        buildingId: string,
        createESMScheduleRequest: CreateESMScheduleRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingEsmSchedule<TData = CreateESMScheduleResponse>(
        buildingId: string,
        createESMScheduleRequest: CreateESMScheduleRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingEsmSchedule<TData = CreateESMScheduleResponse>(
        buildingId: string,
        createESMScheduleRequest: CreateESMScheduleRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingEsmSchedule<TData = CreateESMScheduleResponse>(
        buildingId: string,
        createESMScheduleRequest: CreateESMScheduleRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules`,
                createESMScheduleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules`,
                createESMScheduleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/esm-schedules`,
            createESMScheduleRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Replaces the selected ESM schedule rows, preserving actioned history and applying hard or soft deletes as required.
     * @summary Edit ESM schedule
     */
    updateBuildingEsmSchedule<TData = EditESMScheduleResponse>(
        buildingId: string,
        scheduleId: string,
        editESMScheduleRequest: EditESMScheduleRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingEsmSchedule<TData = EditESMScheduleResponse>(
        buildingId: string,
        scheduleId: string,
        editESMScheduleRequest: EditESMScheduleRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingEsmSchedule<TData = EditESMScheduleResponse>(
        buildingId: string,
        scheduleId: string,
        editESMScheduleRequest: EditESMScheduleRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingEsmSchedule<TData = EditESMScheduleResponse>(
        buildingId: string,
        scheduleId: string,
        editESMScheduleRequest: EditESMScheduleRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}`,
                editESMScheduleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}`,
                editESMScheduleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}`,
            editESMScheduleRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Assigns or clears an organisation for a schedule ESM row. The target organisation must have active building access.
     * @summary Assign organisation to ESM row
     */
    updateBuildingEsmScheduleEsmAssignment<
        TData = AssignESMOrganisationResponse,
    >(
        buildingId: string,
        scheduleId: string,
        esmId: string,
        assignESMOrganisationRequest: AssignESMOrganisationRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingEsmScheduleEsmAssignment<
        TData = AssignESMOrganisationResponse,
    >(
        buildingId: string,
        scheduleId: string,
        esmId: string,
        assignESMOrganisationRequest: AssignESMOrganisationRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingEsmScheduleEsmAssignment<
        TData = AssignESMOrganisationResponse,
    >(
        buildingId: string,
        scheduleId: string,
        esmId: string,
        assignESMOrganisationRequest: AssignESMOrganisationRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingEsmScheduleEsmAssignment<
        TData = AssignESMOrganisationResponse,
    >(
        buildingId: string,
        scheduleId: string,
        esmId: string,
        assignESMOrganisationRequest: AssignESMOrganisationRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}/esms/${esmId}/assignment`,
                assignESMOrganisationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}/esms/${esmId}/assignment`,
                assignESMOrganisationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleId}/esms/${esmId}/assignment`,
            assignESMOrganisationRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a grid-oriented ESM schedule grouped by master for the requested building and schedule year, with optional filtering.
     * @summary Get ESM schedule
     */
    getBuildingEsmScheduleById<TData = GetESMScheduleResponse>(
        buildingId: string,
        scheduleYear: number,
        params?: GetBuildingEsmScheduleByIdParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingEsmScheduleById<TData = GetESMScheduleResponse>(
        buildingId: string,
        scheduleYear: number,
        params?: GetBuildingEsmScheduleByIdParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingEsmScheduleById<TData = GetESMScheduleResponse>(
        buildingId: string,
        scheduleYear: number,
        params?: GetBuildingEsmScheduleByIdParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingEsmScheduleById<TData = GetESMScheduleResponse>(
        buildingId: string,
        scheduleYear: number,
        params?: GetBuildingEsmScheduleByIdParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleYear}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleYear}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/esm-schedules/${scheduleYear}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
}
